import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import StarIcon from '@mui/icons-material/Star';
import * as React from "react";
import {useTranslation} from "react-i18next";
import {Profile} from "crqlar-react-common/dist/models/profile/profile.model";
import {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import AdditionalProperties from "crqlar-react-common/dist/components/AdditionalProperties";
import Property from "crqlar-react-common/dist/components/Property";
import {Stack} from "@mui/material";

interface Props {
    data: UseEntityData<Profile>
}

const Urls = (props: Props) => {

    const {t} = useTranslation()
    const profile = props.data.item
    const setProfile = props.data.setItem
    const updateField = (field: keyof Profile, value: any) => {
        setProfile({...profile, [field]: value})
    }

    const fieldGroupGap = {xs: 3, sm: 2.5}
    const primaryTitle = (title: string) => (
        <Stack
            component={'span'}
            direction={'row'}
            gap={0.5}
            alignItems={'center'}
            sx={{display: 'inline-flex'}}
        >
            <StarIcon sx={{fontSize: '1em', lineHeight: 1, flexShrink: 0}}/>
            <span>{title}</span>
        </Stack>
    )

    return (
        <AdditionalProperties title={t('Urls')} variant={'outlined'} defaultExpanded={!!profile.urls?.length}>
            <Stack gap={fieldGroupGap}>
            {
                profile.urls?.map((url, index) => {
                    const provider = url.externalInfo?.[0]?.provider
                    const disabled = !!provider
                    return (
                        <Property
                            orientation={'vertical'}
                            key={index}
                            title={url.isPrimary ? primaryTitle(t('Primary url')) : t('Url') + ' ' + (index + 1)}
                            subtitle={provider}
                            sx={{
                                title: {
                                    mt: 2,
                                    fontWeight: 'bold'
                                }
                            }}
                        >
                            <Stack
                                gap={1}
                                width={'100%'}
                            >
                                <Property title={t('Url')} labelAlignment={'top'}>
                                    <TextField
                                        id={`url-${index}`}
                                        size={'small'}
                                        value={url.url}
                                        onChange={(e) => {
                                            const urls = [...(profile.urls || [])]
                                            urls[index] = {
                                                ...urls[index],
                                                url: e.target.value
                                            }
                                            updateField('urls', urls)
                                        }}
                                        fullWidth
                                        disabled={disabled}
                                        multiline
                                        rows={3}
                                    />
                                </Property>

                                {
                                    !disabled && (
                                        <Stack
                                            direction={'row'}
                                            gap={1}
                                            justifyContent={'flex-end'}
                                            flexWrap={'wrap'}
                                        >
                                            {
                                                !url.isPrimary && (
                                                    <Button
                                                        variant={'text'}
                                                        size={'small'}
                                                        onClick={() => {
                                                            const urls = [...(profile.urls || [])]
                                                            urls.forEach(e => e.isPrimary = false)
                                                            urls[index] = {
                                                                ...urls[index],
                                                                isPrimary: true
                                                            }
                                                            updateField('urls', urls)
                                                        }}
                                                    >
                                                        {t('Set as primary')}
                                                    </Button>
                                                )
                                            }

                                            <Button
                                                variant={'text'}
                                                size={'small'}
                                                color={'error'}
                                                onClick={() => {
                                                    const urls = [...(profile.urls || [])]
                                                    urls.splice(index, 1)
                                                    updateField('urls', urls)
                                                }}
                                            >
                                                {t('Delete')}
                                            </Button>
                                        </Stack>
                                    )
                                }
                            </Stack>

                        </Property>
                    )
                })
            }


            <Button
                startIcon={<AddIcon/>}
                onClick={() => {
                    const urls = [...(profile.urls || [])]
                    urls.push({url: '', isPrimary: false})
                    updateField('urls', urls)
                }}
                sx={{
                    alignSelf: 'flex-start'
                }}
            >
                {t('Add url')}
            </Button>

            </Stack>
        </AdditionalProperties>
    )
}

export default Urls;
